<style lang="less">
@import "../../../../styles/public/public.less";
@import "../less/district_district.less";
.node_warning {
  width: 94%;
  margin-left: 3%;
  .node_warning_content {
    // text-align: center;
    color: #000;
    padding: 2px;
  }
}
</style>
<template>
  <div class="district_district">
    <div class="district_district1 display_column">
      <div class="district_district_top dispaly_flex00 media_w_w18 display_row_ac">
        <div class="district_district_top_1"></div>
        <span>项目预警</span>
      </div>
      <div class="district_district_bottom dispaly_flex11">
        <div class="node_warning media_w_w14">
          <div v-for="(item,index) in warninfo" class="node_warning_content">
            {{index+1}}.
            <span>{{item.PRJNAME}}项目【</span>

            <span v-if="item.type == 1" style="color:orange;">{{item.DATEDIFF}}</span>
            <span v-else style="color:red;">{{item.DATEDIFF}}</span>

            <span v-if="item.type == 1">】天后将逾期</span>
            <span v-else>】天超期</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "../../../../app/event";
export default {
  components: {},
  data() {
    return {
      warninfo: [
        // {
        //   name:'测试工程',
        //   time:'2',
        //   status:'将逾期'
        // },
        // {
        //   name:'测试课题',
        //   time:'5',
        //   status:'将逾期'
        // },
        // {
        //   name:'测试课题2',
        //   time:'4',
        //   status:'将逾期'
        // },
      ]
    };
  },
  methods: {},
  mounted() {
    bus.$on("proAlert", data => {
      this.warninfo = data;
      for (var i = this.warninfo.length - 1; i >= 0; i--) {
        if (this.warninfo[i].DATEDIFF > 0) {
          this.warninfo[i].type = 1;
        } else {
          this.warninfo[i].DATEDIFF = -this.warninfo[i].DATEDIFF;
          this.warninfo[i].type = 0;
        }
      }
    });
  },
  directives: {}
};
</script>




// WEBPACK FOOTER //
// node_warning.vue?0e87003c